import CustomCard from "components/Atoms/CustomCard"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  VEHICLE_ADD_RECOMMENDATION_ROUTE,
  VEHICLE_SELECT_PLOT_COMMODITY,
} from "store/vehicle.redux"
import classNames from "utils/classNames"
import { getId } from "utils/custom.utils"
import { useTrip } from "./TripContext"
import AppToaster from "utils/AppToaster"

const RecommendationCard = ({ plotCommodity }) => {
  const trip = useTrip()
  const selectedPlotCommodity = useSelector(
    state => state.vehicle.plotCommodity
  )
  const routes = useSelector(state => state.vehicle.recommendations)
  const { registrationCode, plot, variety } = plotCommodity
  const dispatch = useDispatch()
  return (
    <CustomCard
      onClick={e => {
        if (!trip.lat || !trip.lng) {
          return AppToaster.show({
            message:
              "Unable to locate the vehicle for this trip, please ensure that the vehicle is currently active.",
            intent: "warning",
            icon: "warning-sign",
          })
        }
        if (routes?.[plotCommodity?.id]?.routes) {
          dispatch({
            type: VEHICLE_SELECT_PLOT_COMMODITY,
            payload: plotCommodity,
          })
          return null
        } else {
          const directionsService = new window.google.maps.DirectionsService()
          directionsService.route(
            {
              origin: {
                lat: parseFloat(trip?.lat),
                lng: parseFloat(trip?.lng),
              },
              destination: {
                lat: plotCommodity?.plot?.address?.latitude,
                lng: plotCommodity?.plot?.address?.longitude,
              },
              travelMode: "DRIVING",
            },
            (response, status) => {
              if (status === "OK") {
                const routes = response?.routes?.[0]?.overview_path
                dispatch({
                  type: VEHICLE_ADD_RECOMMENDATION_ROUTE,
                  payload: {
                    id: plotCommodity?.id,
                    routes,
                  },
                })
              }
            }
          )
          dispatch({
            type: VEHICLE_SELECT_PLOT_COMMODITY,
            payload: plotCommodity,
          })
        }
      }}
      className={classNames("vt-recomendation-card", {
        "vt-recomendation-card-selected":
          getId(selectedPlotCommodity) === getId(plotCommodity) ? true : false,
      })}
      interactive={true}
    >
      <p className="vt-muted">{registrationCode || "-"}</p>
      <p className="vt-highlight">{plot?.farmer?.fullName || "Na"}</p>
      <p className="vt-highlight">{plot?.address?.village}</p>
      <p className="text-sm">
        {variety?.name} ({variety?.commodity?.name})
      </p>
    </CustomCard>
  )
}

export default RecommendationCard
